import crypto from 'crypto'
import store from "@/store";

const comjs = {}

function isJson(data) {
  try {
    JSON.parse(data);
  } catch (e) {
    return false;
  }
  return true;
}

String.prototype.startWith = function (str) {
    if (str == null || str == "" || this.length == 0 || str.length > this.length) {
        return false;
    }
    if (this.substr(0, str.length) == str) {
        return true;
    } else {
        return false;
    }
    return true;
};

String.prototype.replaceAll = function (s1, s2) {
    return this.replace(new RegExp(s1, "gm"), s2);
}

// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符， 
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字) 
// 例子： 
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423 
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18 

Date.prototype.Format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1,
        "d+": this.getDate(),
        "H+": this.getHours(),
        "m+": this.getMinutes(),
        "s+": this.getSeconds(),
        "S+": this.getMilliseconds()
    };

    //因位date.getFullYear()出来的结果是number类型的,所以为了让结果变成字符串型，下面有两种方法：



    if (/(y+)/.test(fmt)) {
        //第一种：利用字符串连接符“+”给date.getFullYear()+""，加一个空字符串便可以将number类型转换成字符串。

        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {

            //第二种：使用String()类型进行强制数据类型转换String(date.getFullYear())，这种更容易理解。

            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(String(o[k]).length)));
        }
    }
    return fmt;
}

comjs.getFirstDayOfWeek = function (date) {
    var weekday = date.getDay() || 7; //获取星期几,getDay()返回值是 0（周日） 到 6（周六） 之间的一个整数。0||7为7，即weekday的值为1-7
    date.setDate(date.getDate() - weekday + 1); //往前算（weekday-1）天，年份、月份会自动变化
    return date.Format("yyyy-MM-dd");
}

comjs.getEndDayOfWeek = function (date) {
    var weekday = date.getDay() || 7; //获取星期几,getDay()返回值是 0（周日） 到 6（周六） 之间的一个整数。0||7为7，即weekday的值为1-7
    date.setDate(date.getDate() - weekday + 1 + 6); //往前算（weekday-1）天，年份、月份会自动变化
    return date.Format("yyyy-MM-dd");
}

comjs.getFirstDayOfMonth = function (date) {
    date.setDate(1);
    return date.Format("yyyy-MM-dd");
}

comjs.getEndDayOfMonth = function (date) {
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    if (month == 0) {
        month = 12;
        year = year - 1;
    }
    if (month < 10) {
        month = "0" + month;
    }
    var myDate = new Date(year, month, 0);
    return year + "-" + month + "-" + myDate.getDate();
}

comjs.getFirstDayOfYear = function (date) {
    date.setDate(1);
    date.setMonth(0);
    return date.Format("yyyy-MM-dd");
}

comjs.getEndDayOfYear = function (date) {
    var year = date.getFullYear();
    return year + "-12-31";
}

comjs.md5 = function (date) {
    var md5 = crypto.createHash('md5')
    md5.update(date)
    var a = md5.digest('hex')
    return a
}

comjs.setUser = function (user) {
    localStorage.setItem("dealer_user_profile", JSON.stringify(user));
}

comjs.setAdmin = function (user) {
    localStorage.setItem("dealer_user_isAdmin", JSON.stringify(user));
    store.dispatch('user/setAdmin', user)
}

comjs.getUser = function () {
    return isJson('dealer_user_profile') ? JSON.parse(localStorage.getItem("dealer_user_profile")) : {};
}
comjs.getLoginInfo = function () {
    return JSON.parse(localStorage.getItem("loginInfo"));
}

comjs.getAdmin = function () {
    return JSON.parse(localStorage.getItem("dealer_user_isAdmin"));
}

comjs.setDealer = function (dealer) {
    localStorage.setItem("dealer_profile", JSON.stringify(dealer));
    store.dispatch('user/setDealer', dealer)
}
comjs.setLoginInfo = function (loginInfo) {
    localStorage.setItem("loginInfo", JSON.stringify(loginInfo));
    store.dispatch('user/setLoginInfo', loginInfo)
}

comjs.getDealer = function () {
    return JSON.parse(localStorage.getItem("dealer_profile"));
}

comjs.removeDealer = function () {
    localStorage.removeItem("dealer_profile");
}

comjs.setBaseInfo = function (baseInfo) {
    localStorage.setItem("dealer_base_info", JSON.stringify(baseInfo));
    store.dispatch('user/setBaseInfo', baseInfo)
}

comjs.getBaseInfo = function () {
    return JSON.parse(localStorage.getItem("dealer_base_info"));
}

comjs.getRoleName = function (roleId) {
    var baseInfo = JSON.parse(localStorage.getItem("dealer_base_info"));
    var records = baseInfo.dealerMemberRoles
    for (var i = 0; i < records.length; i++) {
        var o = records[i]
        if (o.dataValue == roleId) {
            return o.dataDisplay;
        }
    }
    return ""
}

comjs.uuid = function () {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
}

comjs.formatFileSize = function (fileSize) {
    if (fileSize < 1024) {
        return fileSize + 'B';
    } else if (fileSize < (1024 * 1024)) {
        var temp = fileSize / 1024;
        temp = temp.toFixed(2);
        return temp + 'KB';
    } else if (fileSize < (1024 * 1024 * 1024)) {
        var temp = fileSize / (1024 * 1024);
        temp = temp.toFixed(2);
        return temp + 'MB';
    } else {
        var temp = fileSize / (1024 * 1024 * 1024);
        temp = temp.toFixed(2);
        return temp + 'GB';
    }
}

comjs.isAdmin = function () {
    var dealer = comjs.getDealer();
    if (dealer.role == 1 || dealer.role == 3 || dealer.role == 2 || dealer.role == 6) {
        return true
    } else {
        return false
    }
}

comjs.canDailyReport = function () {
    var dealer = comjs.getDealer();
    return dealer.canDailyReport;
}

comjs.isBoss = function () {
    var dealer = comjs.getDealer();
    if (dealer.role == 2) {
        return true
    } else {
        return false
    }
}

comjs.isFront = function () {
    var dealer = comjs.getDealer();
    if (dealer.role == 1 || dealer.role == 3 || dealer.role == 2 || dealer.role == 6) {
        return true
    }
    if (dealer.role == 5 || dealer.role == 7) {
        return dealer.handleFront
    } else {
        return false
    }
}


comjs.addDate = function (date, days) {
    if (days == undefined || days == '') {
        days = 1;
    }
    var date = new Date(date);
    date.setDate(date.getDate() + days);
    return date;
}

comjs.uuid = function () {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
}
var isWatermark = false;

comjs.watermark = function (watermarkTxt) {
    if (isWatermark) {
        return
    }
    //默认设置
    var defaultSettings = {
        watermark_txt: "text",
        watermark_x: 20, //水印起始位置x轴坐标
        watermark_y: 20, //水印起始位置Y轴坐标
        watermark_rows: 20, //水印行数
        watermark_cols: 20, //水印列数
        watermark_x_space: 50, //水印x轴间隔
        watermark_y_space: 50, //水印y轴间隔
        watermark_color: '#aaa', //水印字体颜色
        watermark_alpha: 0.3, //水印透明度
        watermark_fontsize: '11px', //水印字体大小
        watermark_font: '微软雅黑', //水印字体
        watermark_width: 210, //水印宽度
        watermark_height: 50, //水印长度
        watermark_angle: 30 //水印倾斜度数
    };

    defaultSettings.watermark_txt = watermarkTxt
    //采用配置项替换默认值，作用类似jquery.extend
    
    var oTemp = document.createDocumentFragment();

    //获取页面最大宽度
    var page_width = Math.max(document.body.scrollWidth, document.body.clientWidth);
    var cutWidth = page_width * 0.0150;
    var page_width = page_width - cutWidth;
    //获取页面最大高度
    var page_height = Math.max(document.body.scrollHeight, document.body.clientHeight) + 450;
    // var page_height = document.body.scrollHeight+document.body.scrollTop;
    //如果将水印列数设置为0，或水印列数设置过大，超过页面最大宽度，则重新计算水印列数和水印x轴间隔
    if (defaultSettings.watermark_cols == 0 || (parseInt(defaultSettings.watermark_x + defaultSettings.watermark_width * defaultSettings.watermark_cols + defaultSettings.watermark_x_space * (defaultSettings.watermark_cols - 1)) > page_width)) {
        defaultSettings.watermark_cols = parseInt((page_width - defaultSettings.watermark_x + defaultSettings.watermark_x_space) / (defaultSettings.watermark_width + defaultSettings.watermark_x_space));
        defaultSettings.watermark_x_space = parseInt((page_width - defaultSettings.watermark_x - defaultSettings.watermark_width * defaultSettings.watermark_cols) / (defaultSettings.watermark_cols - 1));
    }
    //如果将水印行数设置为0，或水印行数设置过大，超过页面最大长度，则重新计算水印行数和水印y轴间隔
    if (defaultSettings.watermark_rows == 0 || (parseInt(defaultSettings.watermark_y + defaultSettings.watermark_height * defaultSettings.watermark_rows + defaultSettings.watermark_y_space * (defaultSettings.watermark_rows - 1)) > page_height)) {
        defaultSettings.watermark_rows = parseInt((defaultSettings.watermark_y_space + page_height - defaultSettings.watermark_y) / (defaultSettings.watermark_height + defaultSettings.watermark_y_space));
        defaultSettings.watermark_y_space = parseInt(((page_height - defaultSettings.watermark_y) - defaultSettings.watermark_height * defaultSettings.watermark_rows) / (defaultSettings.watermark_rows - 1));
    }
    var x;
    var y;
    for (var i = 0; i < defaultSettings.watermark_rows; i++) {
        y = defaultSettings.watermark_y + (defaultSettings.watermark_y_space + defaultSettings.watermark_height) * i;
        for (var j = 0; j < defaultSettings.watermark_cols; j++) {
            x = defaultSettings.watermark_x + (defaultSettings.watermark_width + defaultSettings.watermark_x_space) * j;

            var mask_div = document.createElement('div');
            mask_div.id = 'mask_div' + i + j;
            mask_div.className = 'mask_div';
            mask_div.appendChild(document.createTextNode(defaultSettings.watermark_txt));
            //设置水印div倾斜显示
            mask_div.style.webkitTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
            mask_div.style.MozTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
            mask_div.style.msTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
            mask_div.style.OTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
            mask_div.style.transform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
            mask_div.style.visibility = "";
            mask_div.style.position = "absolute";
            mask_div.style.left = x + 'px';
            mask_div.style.top = y + 'px';
            mask_div.style.overflow = "hidden";
            mask_div.style.zIndex = "9999";
            mask_div.style.pointerEvents = 'none'; //pointer-events:none  让水印不遮挡页面的点击事件
            //mask_div.style.border="solid #eee 1px";
            mask_div.style.opacity = defaultSettings.watermark_alpha;
            mask_div.style.fontSize = defaultSettings.watermark_fontsize;
            mask_div.style.fontFamily = defaultSettings.watermark_font;
            mask_div.style.color = defaultSettings.watermark_color;
            mask_div.style.textAlign = "center";
            mask_div.style.width = defaultSettings.watermark_width + 'px';
            mask_div.style.height = defaultSettings.watermark_height + 'px';
            mask_div.style.display = "block";
            oTemp.appendChild(mask_div);
        };
    };
    document.body.appendChild(oTemp);
    isWatermark = true;
}

comjs.parseTime = function (time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if ((typeof time === "string") && (/^[0-9]+$/.test(time))) {
        time = parseInt(time);
    }
    if ((typeof time === "number") && (time.toString().length === 10)) {
        time = time * 1000;
    }
    time = typeof time === "string" ? time.replace(/-/g, '/') : time;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === "a")
      return ["一", "二", "三", "四", "五", "六", "日"][value - 1];
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return time_str;
}

export default comjs;